import React, { useState } from 'react'
// @ts-ignore implicit-any
import ModalVideo from 'react-modal-video'

// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-responsive-images
import { Button, Image } from '@syconium/little-miss-figgy'

import { gql } from '../../../../../../__generated__/graphql/catalog/gql'
import { VideoModalBannerSectionFragmentFragment } from '../../../../../../__generated__/graphql/catalog/graphql'
import { RenderOnceInViewport } from '../../../../../../app/_components/performance/RenderOnceInViewport.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-modal-react-modal-wrapper
import { NextModal } from '../../../../../../components/modals/NextModal'
import { MaybeSpaLinkWrapper } from '../../../../../../lib/adapters/next-routing-service/MaybeSpaLinkWrapper'
import { trackEvent } from '../../../../../../lib/analytics'
import { useImageLoader } from '../../../../../../lib/hooks/useImageLoader'
import { useResponsiveVideoSrc } from '../../../../../../lib/hooks/useResponsiveVideoSrc'
import { InlineVideoPlatforms } from '../../../../../../types/video'
import {
  modalAnimationDuration,
  videoModalBodyOpenClassName,
  videoModalPortalClassName,
} from '../../../../../styles/constants'
import { videoModalStyles } from '../../../../../styles/shared'
import { VimeoVideo } from '../../../../VimeoVideo'

import { Body, Container, ImageWrap, TextWrap, Title } from './styles'

export const VIDEO_MODAL_BANNER_SECTION_FRAGMENT = gql(`
  fragment VideoModalBannerSectionFragment on VideoModalBannerSection {
    id
    body
    ctaText
    heading
    image
    inlineVideo
    inlineVimeoId
    linkHref
    videoId
    videoPlatform
  }
`)

export type VideoModalBannerSectionProps = VideoModalBannerSectionFragmentFragment

export const VideoModalBannerSection: React.FC<VideoModalBannerSectionProps> = ({
  body,
  ctaText,
  heading,
  image,
  inlineVideo,
  inlineVimeoId,
  linkHref,
  videoId,
  videoPlatform,
}) => {
  const { contentfulImageLoader } = useImageLoader()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {
    magnolia: { general },
  } = useTranslation()

  const video = useResponsiveVideoSrc({
    inlineVideoDesktop: inlineVideo,
    inlineVideoMobile: inlineVideo,
    inlineVimeoIdDesktop: inlineVimeoId,
    inlineVimeoIdMobile: inlineVimeoId,
  })

  return (
    <Container data-testid='video-modal-banner-section'>
      <ImageWrap>
        {image && !video && (
          <Image src={contentfulImageLoader({ src: image, quality: 90 })} alt={heading} />
        )}
        {video?.platform === InlineVideoPlatforms.DEFAULT_PLAYER && inlineVideo && (
          <RenderOnceInViewport>
            <video autoPlay loop muted playsInline src={inlineVideo} />
          </RenderOnceInViewport>
        )}
        {video?.platform === InlineVideoPlatforms.VIMEO && (
          <VimeoVideo
            playText={general.playVideo}
            pauseText={general.pauseVideo}
            autoplay
            lazy
            thumbnail={
              image && (
                <Image src={contentfulImageLoader({ quality: 90, src: image })} alt={heading} />
              )
            }
            videoSrc={video.src}
          />
        )}
      </ImageWrap>
      <TextWrap>
        <Title>{heading}</Title>
        <Body>{body}</Body>
        {linkHref ? (
          <MaybeSpaLinkWrapper
            href={linkHref}
            {...trackEvent({ category: 'collection', action: 'click VideoModalBanner link' })}
          >
            <Button as='a' href={linkHref}>
              {ctaText}
            </Button>
          </MaybeSpaLinkWrapper>
        ) : (
          <Button
            {...trackEvent({
              category: 'collection',
              action: 'open video banner modal',
              label: videoPlatform ?? '',
              value: videoId ?? '',
            })}
            onClick={() => setIsModalOpen(true)}
          >
            {ctaText}
          </Button>
        )}
      </TextWrap>
      {videoId && (
        <NextModal
          bodyOpenClassName={videoModalBodyOpenClassName}
          closeTimeoutMS={modalAnimationDuration}
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          portalClassName={videoModalPortalClassName}
          style={videoModalStyles}
        >
          <ModalVideo
            channel={videoPlatform}
            videoId={videoId}
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </NextModal>
      )}
    </Container>
  )
}
